export const EDUCATION = [
  {
    school: 'German University in Cairo',
    degree: 'BSc Computer Science & Engineering',
    period: 'Sep 2015 - Jul 2020',
    note: 'GPA 1.09 (A on the German scale 0.7 - 6.0, where 0.7 is highest).',
  },
  {
    school: 'Ulm University',
    degree: 'Machine Learning Intern · Bachelor project',
    period: 'Mar 2019 - Aug 2019',
    note: 'Conducted machine learning research: built and trained a neural network to recognize Arabic Sign Language, then developed an iOS app that integrated the model for real-world sign language recognition.',
  },
];
